import React from "react";
import { Warning } from "components/icons/components/Warning";
import "./PaymentInfoToast.css";

export const PaymentInfoToast: React.FC = () => {
  return (
    <div className="paymentInfoToastContainer" data-cypress-id="payment-info-toast">
      <Warning />
      <span data-cypress-id="payment-info-toast-text">You'll only be charged after approval.</span>
    </div>
  );
};
